<template slot="acoes" slot-scope="data">
    <span
        class="text-primary">
        <i
            class="fa fa-info-circle fa-lg icon-button"
            title="Detalhar"
            @click.stop="checarDetalharPagamento()"
        ></i>
    </span>
</template>

<script>
import { perfil } from '../../DespesasGeraisPerfis.js'
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },
    },

    methods: {
        checarDetalharPagamento() {
            if (this.$route.name == 'DespesasGerais_Financeiro_Pagamentos'
                && this.$temAcesso('DESP-GERAIS-FINAN-PAG-02')
                && this.pagamento.status == pagamentoStatus.AGUARDANDO_SETOR_FINANCEIRO   
            ) {
                this.iniciarProcessamentoFinanceiro()
            } else {
                this.detalharPagamento()                
            }
        },

        iniciarProcessamentoFinanceiro() {
            this.$store.dispatch('addRequest')
            let processareprovaPagamentoDto = {
                pagamentoId: this.pagamento.pagamentoId,
                acao: 'A',
                detalheReprovacao: null,
                perfil: perfil.FINANCEIRO
            }
            this.pagamentosServicos
                .aprovarReprovarPagamento(processareprovaPagamentoDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.detalharPagamento()                
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        detalharPagamento() {
            this.$router.push({
                name: `${this.$route.name}_Detalhar`,
                params: {
                    pagamentoId: this.pagamento.pagamentoId
                }
            })
        }
    },
}

</script>